import {Link} from 'react-router-dom';
import React/*, { Component }*/ from 'react';
//import ReactDOM from 'react-dom';
import {useracc, postApi, putApi} from '../utils/functions';
//import { cookie, login } from '../utils/protectedroutes';
//import axios from 'axios';
import EventEmitter from '../utils/emmiter';


import {UserContext} from '../utils/usercontext';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
//import Modal from 'react-bootstrap/Modal';

export default class Verify extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
		let key = '';
		let url = window.location.pathname.split('/');
    this.state = {
			key: url[2]?url[2]:'', //this.props.match.params.key,
			status: null,
    };
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		
		document.title = "Verify Account - Mix365 Radio";

		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

		EventEmitter.emit('/client', {data: 'no value'});

		if( this.state.key?.length > 0 ) {
			var params = new URLSearchParams();
			params.append('code', this.state.key);
			const x = await putApi('/api/v2/register/verify', params);
			if( x.status === 201 ) {
				window.location.pathname = '/';
			} else {
				this.setState({status: x.status});
			}
			/*if( x.status === 200 ) {
				this.setState({display: 'password'});
			} else {
				//this.props.history.push('/recover');
				window.location.pathname = 'recover';
			}*/
		}
	}

	render() {
		return (
			<>
				<div className="website-background"></div>
				<Container>
					<Row>
						<Col className="text-center pt-5">
							<img  src="/images/365_Logo.png" alt="Mix365 Logo" width="125" /> Welcome to Mix365 
						</Col>
					</Row>
					<Row className="bigger-box">

						{this.state.status===200 &&
							<Col xs={12}>
								Key not valid
							</Col>
						}
						{this.state.status===210 &&
							<Col xs={12} className="mt-3">
								<h3>Account activated</h3>
								<p>
									<Badge bg="success">Success!</Badge> Thank you for registering with mix365 and your account has now been activated.
								</p>
								<Link to={'/'}><Button size="sm">Return to homepage</Button></Link>
								
							</Col>
						}
						{this.state.status===211 &&
							<Col xs={12} className="mt-3">

								<h3>Email address changed</h3>
								<p>
									<Badge bg="success">Success!</Badge> Your email address has been validated and updated on your account.
								</p>
								<Link to={'/'}><Button size="sm">Return to homepage</Button></Link>

								
								
							</Col>
						}
					</Row>
				</Container>
			</>
		);
	}
}